/**
 * @description is 常量
 * @created 2024/05/13 14:52:25
 */

// 是否为开发环境
const IS_DEV = process.env.NODE_ENV === "development"
// 是否为生产环境
const IS_PROD = process.env.NODE_ENV === "production"

module.exports = {
  IS_DEV,
  IS_PROD
}
